<template>
  <v-app>
    <AppNavigation></AppNavigation>
    <v-content transition="slide-x-transition">
      <router-view id="router-container" class="pb-12"></router-view>
    </v-content>
    <AppFooter></AppFooter>
    <FabSpeedDial></FabSpeedDial>
  </v-app>
</template>
<script>
import AppNavigation from "@/components/common/AppNavigation";
import AppFooter from "@/components/common/AppFooter";
import FabSpeedDial from '@/components/ui/FabSpeedDial.vue'
export default {
  name: "App",
  components: {
    AppNavigation,
    AppFooter,
    FabSpeedDial
  }
};
</script>
<style lang="scss">
.v-content__wrap {
    position: static !important;
}
#router-container {
    background: white;
    background: linear-gradient(to bottom, rgba(255, 255, 255, .8), rgba(255, 255, 255, 0)), url('./assets/backgrounds/1.jpg');
    background-size: cover;
    z-index: -1;
    position: none;
    background-repeat: no-repeat;

}
</style>
